var React = require('react');

function Minimize (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M24 4V16C24 18.1217 23.1571 20.1566 21.6569 21.6569C20.1566 23.1571 18.1217 24 16 24H4M76 24H64C61.8783 24 59.8434 23.1571 58.3431 21.6569C56.8429 20.1566 56 18.1217 56 16V4M4 56H16C18.1217 56 20.1566 56.8429 21.6569 58.3431C23.1571 59.8434 24 61.8783 24 64V76M56 76V64C56 61.8783 56.8429 59.8434 58.3431 58.3431C59.8434 56.8429 61.8783 56 64 56H76","stroke":"black","strokeWidth":"8","strokeLinecap":"round","strokeLinejoin":"round"}));
}

Minimize.defaultProps = {"width":"80","height":"80","viewBox":"0 0 80 80","fill":"none"};

module.exports = Minimize;

Minimize.default = Minimize;
